module.exports = __webpack_public_path__ + "img/vk.441b18d0.svg";